// extracted by mini-css-extract-plugin
export default {"announcements":"V_f8 p-2","announcement":"V_f9 card my-2","announcement--highlighted":"V_gb","announcement__list-item":"V_gc py-1","announcement__flag":"V_gd"};